import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/app/app';

const root = ReactDOM.createRoot(document.getElementById('favorites-modal'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
